/*
 *   Code is a modified version of the following:
 *   https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-2/js/tabs.js
 */
export var tabsNav = function (tabComponent) {
    var keys = {
        end: 35,
        home: 36,
        left: 37,
        right: 39,
        enter: 13,
        space: 32
    };
    var tabs = tabComponent && tabComponent.querySelectorAll('[role="tab"]');
    for (var i = 0; i < tabs.length; i++) {
        var tab = tabs[i];
        tab.addEventListener('click', function (e) { return activateCurrentTab(e); });
        tab.addEventListener('keydown', function (e) { return keydownEventListener(e); });
        tab.addEventListener('keyup', function (e) { return keyupEventListener(e); });
        // add index property to the tab object, to be used switchTabOnArrowPress fn
        tab.index = i;
    }
    var activateCurrentTab = function (event) {
        var currentTab = event.target;
        deactivateOtherTabs();
        currentTab && currentTab.removeAttribute('tabindex');
        currentTab && currentTab.setAttribute('aria-selected', 'true');
        currentTab && currentTab.focus();
    };
    var deactivateOtherTabs = function () {
        for (var i = 0; i < tabs.length; i++) {
            var tab = tabs[i];
            tab.setAttribute('tabindex', '-1');
            tab.setAttribute('aria-selected', 'false');
        }
    };
    var focusLastTab = function () {
        tabs[tabs.length - 1].focus();
    };
    var focusFirstTab = function () {
        tabs[0].focus();
    };
    var keydownEventListener = function (event) {
        switch (event.keyCode) {
            case keys.end:
                event.preventDefault();
                focusLastTab();
                break;
            case keys.home:
                event.preventDefault();
                focusFirstTab();
                break;
        }
    };
    var keyupEventListener = function (event) {
        var key = event.keyCode;
        switch (key) {
            case keys.left:
            case keys.right:
                switchTabOnArrowPress(event);
                break;
            case keys.enter:
            case keys.space:
                activateCurrentTab(event);
                break;
        }
    };
    var switchTabOnArrowPress = function (event) {
        var keyCode = event.keyCode;
        var target = event.target;
        var direction = {
            37: -1,
            39: 1 // right
        };
        var nextTab = target && target.index + direction[keyCode];
        if (direction[keyCode] && target && target.index !== undefined) {
            if (tabs[nextTab]) {
                tabs[nextTab].focus();
            }
            else if (keyCode === keys.left) {
                focusLastTab();
            }
            else if (keyCode === keys.right) {
                focusFirstTab();
            }
        }
    };
};
//# sourceMappingURL=tabsNavigation.js.map